import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import IdCopyView from "../../../../Components/ToothFairyComponents/IdCopyView";

const DetailRow = ({ label, value, icon, currentTheme }) => (
  <View
    style={{
      flexDirection: "row",
      alignItems: "flex-start",
      marginVertical: 6,
    }}
  >
    <AppText preventTranslation fontWeight="bold" style={{ minWidth: 120 }}>
      {label}
    </AppText>
    <AppText preventTranslation style={{ flexShrink: 1 }}>
      {value ?? "—"}
    </AppText>
  </View>
);

const SupportLogView = ({ log }) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  return (
    <View
      style={{
        paddingLeft: 23,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 10,
        rowGap: 4,
      }}
    >
      <IdCopyView
        id={log?.log?.id || log?.id}
        label={t("admin.humanFeedback.id")}
        wrapperStyle={{ marginTop: 0, marginLeft: 0 }}
      />
      <View style={{ marginTop: 10 }}>
        <DetailRow
          label={t("admin.support.history.datetime")}
          value={log?.datetime}
          currentTheme={currentTheme}
        />
        <DetailRow
          label={t("admin.support.history.engineer")}
          value={log?.engineer}
          currentTheme={currentTheme}
        />
        <DetailRow
          label={t("admin.support.history.hours")}
          value={log?.hours != null ? `${log?.hours} h` : null}
          currentTheme={currentTheme}
        />
      </View>
      <View
        style={{
          borderTopWidth: 1,
          borderTopColor: currentTheme?.theme?.border_color,
          marginVertical: 8,
        }}
      />
      <AppText preventTranslation fontWeight="bold">
        {t("admin.support.history.description")}
      </AppText>
      <AppText
        preventTranslation
        wrapperStyle={{ marginTop: 4 }}
        color={currentTheme?.theme?.secondary_font_color}
      >
        {log?.description || t("admin.humanFeedback.none")}
      </AppText>
    </View>
  );
};

export default SupportLogView;
